/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItRadiationtUnitDto
 */
export interface TrackItRadiationtUnitDto {
    /**
     * 
     * @type {number}
     * @memberof TrackItRadiationtUnitDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItRadiationtUnitDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItRadiationtUnitDto
     */
    $type?: TrackItRadiationtUnitDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItRadiationtUnitDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItRadiationtUnitDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItRadiationtUnitDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItRadiationtUnitDtoTypeEnum = typeof TrackItRadiationtUnitDtoTypeEnum[keyof typeof TrackItRadiationtUnitDtoTypeEnum];



/**
 * Check if a given object implements the TrackItRadiationtUnitDto interface.
 */
export function instanceOfTrackItRadiationtUnitDto(value?: unknown): value is TrackItRadiationtUnitDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItRadiationtUnitDtoTypeEnum)[0];
}

export function TrackItRadiationtUnitDtoFromJSON(json: any): TrackItRadiationtUnitDto {
    return TrackItRadiationtUnitDtoFromJSONTyped(json, false);
}

export function TrackItRadiationtUnitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItRadiationtUnitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItRadiationtUnitDtoToJSON(value?: TrackItRadiationtUnitDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        '$type': value['$type'],
    });
}

